import { render, staticRenderFns } from "./SingleFileUpload.vue?vue&type=template&id=20db899c&scoped=true"
import script from "./SingleFileUpload.vue?vue&type=script&lang=js"
export * from "./SingleFileUpload.vue?vue&type=script&lang=js"
import style0 from "./SingleFileUpload.vue?vue&type=style&index=0&id=20db899c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20db899c",
  null
  
)

export default component.exports